module.exports = __webpack_public_path__ + "static/media/logo.45eaea3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/logo.png
// module id = 286
// module chunks = 0